/**
 * i18n Type Definitions & Constants
 * Single source of truth for all language-related constants.
 */
// Supported languages — add new languages here + create locale files in each app
export const SUPPORTED_LANGUAGES = ['en', 'he', 'es', 'fr', 'de', 'ar', 'pt-BR', 'it', 'ru', 'yi', 'am', 'ja'];
// RTL languages
export const RTL_LANGUAGES = ['he', 'ar', 'yi'];
// Language display names (in their native language)
export const LANGUAGE_NAMES = {
    en: 'English',
    he: 'עברית',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    ar: 'العربية',
    'pt-BR': 'Português (BR)',
    it: 'Italiano',
    ru: 'Русский',
    yi: 'ייִדיש',
    am: 'አማርኛ',
    ja: '日本語',
};
// Short language codes for compact display (e.g., PWA language switchers)
export const LANGUAGE_CODES = {
    en: 'EN',
    he: 'עב',
    es: 'ES',
    fr: 'FR',
    de: 'DE',
    ar: 'عر',
    'pt-BR': 'PT',
    it: 'IT',
    ru: 'RU',
    yi: 'יי',
    am: 'AM',
    ja: 'JA',
};
// Intl locale codes for Intl.DateTimeFormat / Intl.NumberFormat
export const LOCALE_MAP = {
    en: 'en-US',
    he: 'he-IL',
    es: 'es-ES',
    fr: 'fr-FR',
    de: 'de-DE',
    ar: 'ar-SA',
    'pt-BR': 'pt-BR',
    it: 'it-IT',
    ru: 'ru-RU',
    yi: 'yi',
    am: 'am-ET',
    ja: 'ja-JP',
};
// All supported languages with metadata
export const LANGUAGES = [
    { code: 'en', label: 'English', native: 'English', rtl: false },
    { code: 'he', label: 'Hebrew', native: 'עברית', rtl: true },
    { code: 'es', label: 'Spanish', native: 'Español', rtl: false },
    { code: 'fr', label: 'French', native: 'Français', rtl: false },
    { code: 'de', label: 'German', native: 'Deutsch', rtl: false },
    { code: 'ar', label: 'Arabic', native: 'العربية', rtl: true },
    { code: 'pt-BR', label: 'Portuguese (BR)', native: 'Português (BR)', rtl: false },
    { code: 'it', label: 'Italian', native: 'Italiano', rtl: false },
    { code: 'ru', label: 'Russian', native: 'Русский', rtl: false },
    { code: 'yi', label: 'Yiddish', native: 'ייִדיש', rtl: true },
    { code: 'am', label: 'Amharic', native: 'አማርኛ', rtl: false },
    { code: 'ja', label: 'Japanese', native: '日本語', rtl: false },
];
// Default fallback language
export const FALLBACK_LNG = 'en';
/**
 * The supported language for a client-supplied tag (ja-JP -> ja, pt -> pt-BR),
 * or the fallback. Use on any language value from a public request before it
 * picks content or drives a model call.
 */
export function toSupportedLanguage(input, fallback = FALLBACK_LNG) {
    if (!input)
        return fallback;
    const lower = input.toLowerCase();
    const exact = SUPPORTED_LANGUAGES.find((l) => l.toLowerCase() === lower);
    if (exact)
        return exact;
    const base = lower.split('-')[0];
    return SUPPORTED_LANGUAGES.find((l) => l.split('-')[0].toLowerCase() === base) ?? fallback;
}
//# sourceMappingURL=types.js.map